(() => {
  const selector = 'img[src*="ecocut-complete-set-zwart-20261028.png"], img[src*="ecocut-complete-set-lichtbruin-20261028.png"]';
  const overlays = new Map();
  const observed = new WeakSet();
  const ns = 'http://www.w3.org/2000/svg';
  let serial = 0;
  let pending = false;
  const resize = new ResizeObserver(schedule);
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; sync(); });
  }
  function create(img) {
    const parent = img.parentElement;
    if (!parent || getComputedStyle(parent).display === 'contents') return null;
    if (getComputedStyle(parent).position === 'static') parent.style.position = 'relative';
    const svg = document.createElementNS(ns, 'svg');
    const id = 'ec-ground-shadow-' + (++serial);
    svg.setAttribute('viewBox', '0 0 1600 1600');
    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    svg.setAttribute('aria-hidden', 'true');
    svg.classList.add('ec-photo-shadow');
    svg.innerHTML = '<defs><filter id="' + id + '" x="-50%" y="-200%" width="200%" height="500%"><feGaussianBlur stdDeviation="5"/></filter></defs><g class="ec-tool-shadow" fill="#272720" opacity=".28" filter="url(#' + id + ')"><ellipse cx="1058" cy="1138" rx="74" ry="7"/><ellipse cx="1203" cy="1138" rx="72" ry="7"/><ellipse cx="1348" cy="1138" rx="74" ry="7"/></g><g fill="#272720" opacity=".26" filter="url(#' + id + ')"><ellipse cx="625" cy="1086" rx="278" ry="10"/><ellipse cx="215" cy="854" rx="110" ry="8" transform="rotate(4 215 854)"/></g>';
    Object.assign(svg.style, {position:'absolute',pointerEvents:'none',display:'block',zIndex:'1'});
    parent.append(svg);
    overlays.set(img, svg);
    if (!observed.has(img)) {
      observed.add(img);
      resize.observe(img);
      resize.observe(parent);
      img.addEventListener('load', schedule);
    }
    return svg;
  }
  function sync() {
    for (const [img, svg] of overlays) {
      if (!img.isConnected || !img.matches(selector) || svg.parentElement !== img.parentElement) {
        svg.remove(); overlays.delete(img);
      }
    }
    document.querySelectorAll(selector).forEach(img => {
      const svg = overlays.get(img) || create(img);
      if (!svg) return;
      svg.querySelector('.ec-tool-shadow').style.display = img.src.includes('ecocut-complete-set-zwart-20261028.png') ? '' : 'none';
      const box = img.getBoundingClientRect();
      const parent = img.parentElement;
      const origin = parent.getBoundingClientRect();
      Object.assign(svg.style, {left:(box.left-origin.left-parent.clientLeft+parent.scrollLeft)+'px',top:(box.top-origin.top-parent.clientTop+parent.scrollTop)+'px',width:box.width+'px',height:box.height+'px'});
    });
  }
  new MutationObserver(records => {
    if (records.some(r => r.type === 'attributes' ? r.target.tagName === 'IMG' : [...r.addedNodes, ...r.removedNodes].some(n => n.nodeType === 1 && (n.tagName === 'IMG' || n.querySelector?.('img'))))) schedule();
  }).observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['src','srcset']});
  window.addEventListener('resize',schedule,{passive:true});
  document.addEventListener('shopify:section:load',schedule);
  schedule();
})();